import _ from "lodash";
import type { IScope } from "reducers/scope";

export const canAccessAssortments = (me, scope: IScope) => {
    return (
        (me.account_type === "buyer" && (me.hasCollectionsAccess() || scope.brand?.hasModuleEnabled("assortments"))) ||
        (me.account_type === "brand" && scope.brand?.hasModuleEnabled("assortments")) ||
        (me.account_type === "nuorder" &&
            _.some(me.merchant_connections, (merchant) => _.includes(merchant.capabilities, "assortments")))
    );
};
